import React, { FC } from 'react';
import { SidebarHeading } from '../../SidebarHeading';
import { HelpOutline } from '@mui/icons-material';
import { Alert } from '@mui/material';
import { useReferencesContext } from '../ReferencesContext';
import { StyledHeader } from '../styles';
import { JSONContent } from '@tiptap/core';
import { InternalNodeLink } from './InternalNodeLink';

export const MissingReferences: FC = () => {
  const { missingReferences, hasMissingReferences } = useReferencesContext();
  if (!hasMissingReferences) {
    return <Alert severity="success">Dokumentet inneholder ingen manglende referanser.</Alert>;
  }
  return (
    <div>
      <SidebarHeading icon={<HelpOutline />}>Manglende referanser</SidebarHeading>
      <Alert severity="warning">Tabeller, figurer, grafer og apper skal være referert i teksten. Sjekk at alle referanser er lagt til.</Alert>
      <MissingReferencesSection nodes={missingReferences.tables} heading="Tabeller som mangler referanse" />
      <MissingReferencesSection nodes={missingReferences.figures} heading="Figurer som mangler referanse" />
      <MissingReferencesSection nodes={missingReferences.apps} heading="Apper som mangler referanse" />
    </div>
  );
};

const MissingReferencesSection: FC<{ nodes: JSONContent[]; heading: string }> = ({ nodes, heading }) => {
  if (nodes.length === 0) return null;
  return (
    <>
      <StyledHeader>{heading}</StyledHeader>
      {nodes.map((node, index) => (
        <InternalNodeLink key={index} id={node.attrs?.id} />
      ))}
    </>
  );
};
